// extracted by mini-css-extract-plugin
export default {"talentDetail":"style_talentDetail__91s9B","videoContainer":"style_videoContainer__8FOI7","contactUser":"style_contactUser__Rr2Jo"};